// app/providers.jsx
"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";
export function PostHogProvider({
  children
}) {
  useEffect(() => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      capture_pageview: false,
      // Disable automatic pageview capture, as we capture manually
      capture_pageleave: true,
      // Share the distinct_id cookie across www <-> app subdomains (.arbeitszeittracker.de)
      // so the anonymous www journey merges into the user on sign-up (attribution fix).
      // MUST match the website repo (worktime-website/app/providers.jsx).
      cross_subdomain_cookie: true
    });
  }, []);
  return <PHProvider client={posthog} data-sentry-element="PHProvider" data-sentry-component="PostHogProvider" data-sentry-source-file="providers.jsx">{children}</PHProvider>;
}